<div class="flex-layout center-content">
  <div class="ops-header item-grow">
    <a routerLink="/operational-dashboard/errors-by-component">Errors By Component</a>
    <div class="filter-box">
      <insight-filters [layoutDirection]="'row'"
        [filtersSubject]="filtersSubject"
        [showMinShipFilter]="false"
        [showMaxShipFilter]="false"
        [showCheckboxFilters]="false"
        [shouldSetUrlPrams]="false"
        [showStatusFilter]="false">
      </insight-filters>
    </div>
  </div>
</div>

@if (isLoading) {
  <insight-loading-spinner loadingMessage="Loading...">
  </insight-loading-spinner>
}

@if (didError) {
  <div class="flex-layout center-content">
    <div>
      An error occurred while getting order shipments.
    </div>
  </div>
}

@if (!isLoading) {
  <div class="flex-layout column stretch-items">
    <legend-item [legendItems]="legendItems" [showFilter]="false">
    </legend-item>
    <div class="chart-container">
      <ngx-charts-bar-vertical-stacked [scheme]="chartColors"
        [results]="filteredChartData"
        [gradient]="false"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="false"
        [showXAxisLabel]="true"
        [showYAxisLabel]="true"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [animations]="true">
      </ngx-charts-bar-vertical-stacked>
    </div>
  </div>
}
